module.exports = __webpack_public_path__ + "static/img/epic.89e06bcf.png";